const API_BASE_URL = (typeof window !== 'undefined' && (window as any).ENV?.EXPO_PUBLIC_MARKET_PRICE_API_URL) || '';

export interface MarketPrice {
  id: string;
  cereal: string;
  price_per_ton: number;
  variation_percent: number;
  published_at: string;
  created_at: string;
}

export async function fetchMarketPrices(token: string): Promise<MarketPrice[]> {
  const response = await fetch(`${API_BASE_URL}/market-prices`, {
    headers: {
      "Authorization": `Bearer ${token}`
    }
  });

  if (!response.ok) {
    throw new Error("Failed to fetch market prices");
  }

  const result = await response.json();
  return result.data;
}

export async function publishMarketPrices(
  prices: { cereal: string; price: number }[],
  token: string
): Promise<any> {
  const response = await fetch(`${API_BASE_URL}/market-prices/publish`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
    },
    body: JSON.stringify(prices)
  });

  if (!response.ok) {
    const errData = await response.json().catch(() => ({}));
    throw new Error(errData.message || "Failed to publish market prices");
  }

  return response.json();
}

export async function seedMarketPrices(token: string): Promise<any> {
  const response = await fetch(`${API_BASE_URL}/market-prices/seed`, {
    method: "POST",
    headers: {
      "Authorization": `Bearer ${token}`
    }
  });

  if (!response.ok) {
    throw new Error("Failed to seed market prices");
  }

  return response.json();
}
